module.exports = __webpack_public_path__ + "img/icon-facebook.e0f9fc0d28f1ac3a6d0b18d99be2bacb.svg";